import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import {PopupType} from "../popups/popupType";
import {Application} from "../application";
import * as ko from "knockout";

export class OpenCostbookPropertiesPopupCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.OpenCostbookPropertiesPopup;
    canExecute = ko.computed(() => {
        return this.app.state.costbook() != undefined;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        return this.app.popupsManager.show(PopupType.costbookProperties, true);
    }

    name = "Costbook Properties";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/openCostbookPropertiesPopupCommand.ts